import angular, { IPromise } from "angular";
import { IAlertRuleRecord } from "src/app/main/modules/alerts/_models/alerts.interfaces";
import { TranslationService } from "@services/translation.service";
import { IPowerLossHistory } from "@interfaces/IPowerLossHistory";
import { PowerLossHistoryService } from "@services/powerLossHistory.service";

export interface IPowerLossAlertDetailData {
    history?: IPowerLossHistory;
}

export class PowerLossAlertDetailService {
    static $inject = ["$q", "translationService", "powerLossHistoryService"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly translationService: TranslationService,
        private readonly powerLossHistoryService: PowerLossHistoryService) {
    }

    getAlertExport(record: IAlertRuleRecord): IPromise<string> {
        return this.getAlertData(record).then((data) => {
            return `${this.createAlertLabel(data)}`;
        }).catch((error) => {
            console.error("Error retrieving power loss alert detail: ", error);

            return null
        });
    }

    createAlertLabel(data: IPowerLossAlertDetailData): string {
        return `${data.history?.Source} ${this.translationService.t('Alerts.LostPower')}`;
    }

    getAlertData(record: IAlertRuleRecord): IPromise<IPowerLossAlertDetailData> {
        const promises = [];
        const data: IPowerLossAlertDetailData = {};

        promises.push(this.getPowerLossHistory(record, data));

        return this.$q.all(promises).then(() => {
            return data;
        });
    }

    private getPowerLossHistory(record: IAlertRuleRecord, data: IPowerLossAlertDetailData): angular.IPromise<void> {
        if (!record.alertMetadata.PowerLossHistoryId) {
            return this.$q.resolve();
        }

        return this.powerLossHistoryService.getPowerLossHistory(record.alertMetadata.PowerLossHistoryId).then(
            history => {
                data.history = history;
            });
    }
}
